import { render, staticRenderFns } from "./ModalLeavePage.vue?vue&type=template&id=480f93a6"
import script from "./ModalLeavePage.vue?vue&type=script&lang=js"
export * from "./ModalLeavePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports